export const experiences = [
    {
        "company": "Freelance",
        "title": "Full-Stack Engineer",
        "years": "2020 — Present · Paris",
        "logo": "menu",
        "mainTech": [
            "React · React-Native · Expo"
        ],
        "technologies": [
            "React",
            "React-Native",
            "Expo",
            "Firebase",
            "Tailwind",
            "TypeScript"
        ],
        "description": "End-to-end frontend ownership across multiple side engagements. Flagship: PassCE — web app + Expo mobile app for a corporate benefits platform reaching 10,000+ daily users.",
        "color": "#fff"
    },
    {
        "company": "Crédit Agricole Technologies & Services",
        "title": "Software Engineer",
        "years": "Mar 2020 — Sep 2020 · Paris",
        "logo": "menu",
        "mainTech": [
            "Java / JavaScript"
        ],
        "technologies": [
            "Java",
            "MySQL",
            "JavaScript",
            "HTML",
            "CSS"
        ],
        "description": "Software engineering inside the bank's internal technology division. Backend and frontend work on banking applications.",
        "color": "#fff"
    }
];

export const basic_info = {
    "section_name": {
        "about": "About me",
        "projects": "Projects",
        "skills": "Skills",
        "experience": "Experience"
    }
};
